export const Performance_Q1_Check_Details = [
  {
    CheckId: "dedicated_master_check",
    Description: "Elasticsearch dedicated masters used",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "ebs_obtimized_instance_with_iops_check",
    Description: "Amazon EBS optimized instances with Provisioned IOPS volumes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "ecs_cluster_default_provider_strategy_check",
    Description: "ECS default cluster provider configured",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "api_gateway_stage_caching_enabled_check",
    Description: "API Gateway stage caching enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
];

export const Performance_Q1_dedicated_master_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q1_ebs_obtimized_instance_with_iops_check = {
  CurrentOffset: 0,
  Limit: 10,
  NextOffset: 1,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_obtimized_instance_with_iops_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "021637a5-4ed8-400e-b494-7a9e13f94064",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "performing-architecture",
      Recommendation:
        "Checks for Provisioned IOPS (SSD) volumes that are attached to an Amazon EBS-optimizable Amazon Elastic Compute Cloud (Amazon EC2) instance that is not EBS-optimized. Provisioned IOPS (SSD) volumes in the Amazon Elastic Block Store (Amazon EBS) are designed to deliver the expected performance only when they are attached to an EBS-optimized instance.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-06ffbd8c4acb516a1",
      ResourceType: "Volume",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_obtimized_instance_with_iops_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "0d73bf76-7e65-45ed-8c8e-8bb8a3f22b84",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "performing-architecture",
      Recommendation:
        "Checks for Provisioned IOPS (SSD) volumes that are attached to an Amazon EBS-optimizable Amazon Elastic Compute Cloud (Amazon EC2) instance that is not EBS-optimized. Provisioned IOPS (SSD) volumes in the Amazon Elastic Block Store (Amazon EBS) are designed to deliver the expected performance only when they are attached to an EBS-optimized instance.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-02d23369d29e03152",
      ResourceType: "Volume",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_obtimized_instance_with_iops_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "0e54afa6-f985-448e-adc3-9145ff21b2ac",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "performing-architecture",
      Recommendation:
        "Checks for Provisioned IOPS (SSD) volumes that are attached to an Amazon EBS-optimizable Amazon Elastic Compute Cloud (Amazon EC2) instance that is not EBS-optimized. Provisioned IOPS (SSD) volumes in the Amazon Elastic Block Store (Amazon EBS) are designed to deliver the expected performance only when they are attached to an EBS-optimized instance.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-0ea6b0db4290bf8cb",
      ResourceType: "Volume",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_obtimized_instance_with_iops_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "2fa86fea-94f3-476d-a5c1-27c97e034c19",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "performing-architecture",
      Recommendation:
        "Checks for Provisioned IOPS (SSD) volumes that are attached to an Amazon EBS-optimizable Amazon Elastic Compute Cloud (Amazon EC2) instance that is not EBS-optimized. Provisioned IOPS (SSD) volumes in the Amazon Elastic Block Store (Amazon EBS) are designed to deliver the expected performance only when they are attached to an EBS-optimized instance.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-0faf25aeab3cb0efa",
      ResourceType: "Volume",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_obtimized_instance_with_iops_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "35047fd6-b51e-4fd2-abe0-191cb2e5845c",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "performing-architecture",
      Recommendation:
        "Checks for Provisioned IOPS (SSD) volumes that are attached to an Amazon EBS-optimizable Amazon Elastic Compute Cloud (Amazon EC2) instance that is not EBS-optimized. Provisioned IOPS (SSD) volumes in the Amazon Elastic Block Store (Amazon EBS) are designed to deliver the expected performance only when they are attached to an EBS-optimized instance.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-05ef2b3341707c934",
      ResourceType: "Volume",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_obtimized_instance_with_iops_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "41bc3de7-8972-417b-86de-2745ef0d42a2",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "performing-architecture",
      Recommendation:
        "Checks for Provisioned IOPS (SSD) volumes that are attached to an Amazon EBS-optimizable Amazon Elastic Compute Cloud (Amazon EC2) instance that is not EBS-optimized. Provisioned IOPS (SSD) volumes in the Amazon Elastic Block Store (Amazon EBS) are designed to deliver the expected performance only when they are attached to an EBS-optimized instance.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-03698fec3b83c21aa",
      ResourceType: "Volume",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_obtimized_instance_with_iops_check",
      CreatedAt: "2023-04-25 12:24:03",
      FindingId: "6673bcdb-3b9a-463c-a2e9-54b5b9a9cf4e",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "performing-architecture",
      Recommendation:
        "Checks for Provisioned IOPS (SSD) volumes that are attached to an Amazon EBS-optimizable Amazon Elastic Compute Cloud (Amazon EC2) instance that is not EBS-optimized. Provisioned IOPS (SSD) volumes in the Amazon Elastic Block Store (Amazon EBS) are designed to deliver the expected performance only when they are attached to an EBS-optimized instance.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-00390a16574adf858",
      ResourceType: "Volume",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_obtimized_instance_with_iops_check",
      CreatedAt: "2023-04-25 12:24:03",
      FindingId: "6765acb1-99fd-4342-9fd6-c68b1212d2b8",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "performing-architecture",
      Recommendation:
        "Checks for Provisioned IOPS (SSD) volumes that are attached to an Amazon EBS-optimizable Amazon Elastic Compute Cloud (Amazon EC2) instance that is not EBS-optimized. Provisioned IOPS (SSD) volumes in the Amazon Elastic Block Store (Amazon EBS) are designed to deliver the expected performance only when they are attached to an EBS-optimized instance.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-006628696d6276613",
      ResourceType: "Volume",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_obtimized_instance_with_iops_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "6deb45cd-83e5-446f-b6e1-a33f3b0c9236",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "performing-architecture",
      Recommendation:
        "Checks for Provisioned IOPS (SSD) volumes that are attached to an Amazon EBS-optimizable Amazon Elastic Compute Cloud (Amazon EC2) instance that is not EBS-optimized. Provisioned IOPS (SSD) volumes in the Amazon Elastic Block Store (Amazon EBS) are designed to deliver the expected performance only when they are attached to an EBS-optimized instance.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-03d385d8a15e6912b",
      ResourceType: "Volume",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "ebs_obtimized_instance_with_iops_check",
      CreatedAt: "2023-04-25 12:24:04",
      FindingId: "991971c3-88a1-4fad-900e-765f47ce881a",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "performing-architecture",
      Recommendation:
        "Checks for Provisioned IOPS (SSD) volumes that are attached to an Amazon EBS-optimizable Amazon Elastic Compute Cloud (Amazon EC2) instance that is not EBS-optimized. Provisioned IOPS (SSD) volumes in the Amazon Elastic Block Store (Amazon EBS) are designed to deliver the expected performance only when they are attached to an EBS-optimized instance.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "vol-04519c70f234c739a",
      ResourceType: "Volume",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 11,
};
export const Performance_Q1_ecs_cluster_default_provider_strategy_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q1_api_gateway_stage_caching_enabled_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "api_gateway_stage_caching_enabled_check",
      CreatedAt: "2023-04-25 12:24:17",
      FindingId: "1574e342-90e7-49cd-a40e-404da45318f7",
      Metadata: {
        TaskRefId: "0932b4b2-de9f-4a21-a98b-0f9913a05618",
      },
      PillarId: "performance",
      QuestionId: "performing-architecture",
      Recommendation:
        "Enable API caching in Amazon API Gateway to cache your endpoint's responses. With caching, you can reduce the number of calls made to your endpoint and also improve the latency of requests to your API.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:apigateway:us-east-1::/restapis/2edfnla881/stages/unencrpytcache",
      ResourceType: "APIGatewayStage",
      Severity: "Medium",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "api_gateway_stage_caching_enabled_check",
      CreatedAt: "2023-04-25 12:24:17",
      FindingId: "eb0915e5-ad82-4284-a2db-9d94293fae1c",
      Metadata: {
        TaskRefId: "0932b4b2-de9f-4a21-a98b-0f9913a05618",
      },
      PillarId: "performance",
      QuestionId: "performing-architecture",
      Recommendation:
        "Enable API caching in Amazon API Gateway to cache your endpoint's responses. With caching, you can reduce the number of calls made to your endpoint and also improve the latency of requests to your API.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:apigateway:us-east-1::/restapis/2edfnla881/stages/dev",
      ResourceType: "APIGatewayStage",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};

export const Performance_Q6_Check_Details = [
  {
    CheckId: "eks_latest_k8s_version_check",
    Description: "EKS Latest K8s version",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "dms_replication_instance_minor_version_update_check",
    Description:
      "Database Migration Service instances should be configured to have minor version updates be automatically applied",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "broker_minor_version_auto_upgrade_check",
    Description: "Amazon MQ message brokers latest minor version",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "elastic_update_check",
    Description: "Elasticsearch available version updates",
    ErrorMessages: null,
    Status: "PASSED",
  },
];

export const Performance_Q6_eks_latest_k8s_version_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q6_dms_replication_instance_minor_version_update_check =
  {
    CurrentOffset: 0,
    Limit: 10,
    Records: [],
    TotalRecords: 0,
  };
export const Performance_Q6_broker_minor_version_auto_upgrade_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q6_elastic_update_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};

export const Performance_Q7_Check_Details = [
  {
    CheckId: "documentdb_cluster_audit_logging_on",
    Description: "Ensure DocDB cluster audit logging is turned on",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "emr_cluster_logging_check",
    Description: "EMR cluster logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "cloud_trail_s3_bucket_logging_enabled_check",
    Description:
      "S3 bucket access logging is enabled on the CloudTrail S3 bucket",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_vpc_changes",
    Description: "Ensure a log metric filter and alarm exist for VPC changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "is_stage_api_logging_enabled",
    Description: "Ensure stage API logging enabled on API Gateway",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "blockchain_fabric_peer_node_logs_enabled",
    Description:
      "Peer node logs allow you to debug timeout errors associated with proposals and identify rejected proposals",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "ram_resource_shares_status_check",
    Description: "Resource share should not have a failed status",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "amb_fabric_node_chaincode_logging_check",
    Description: "Fabric peer node chaincode logs enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "log_metric_filter_for_route_table_changes",
    Description:
      "Ensure a log metric filter and alarm exist for route table changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "rds_instance_cloudwatch_logging_check",
    Description: "Enable CloudWatch logging for RDS databases ",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_network_gateway_changes",
    Description:
      "Ensure a log metric filter and alarm exist for changes to network gateways",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "kinesis_analytics_application_log_to_cloudwatch_check",
    Description: "Kinesis analytics application log to CloudWatch",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "are_stacks_monitored",
    Description: "Ensure cloudformation stacks are monitored",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "amb_fabric_member_ca_logging_check",
    Description: "Fabric member CA logs enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "log_metric_filter_for_aws_config_changes",
    Description:
      "Ensure a log metric filter and alarm exist for AWS Config configuration changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_s3_changes",
    Description:
      "Ensure a log metric filter and alarm exist for S3 bucket policy changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "is_cloudwatch_logging_enabled",
    Description:
      "Ensure CloudWatch logging enabled for CodeBuild for audit pupose.",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "elbv2_nlb_tls_logging_check",
    Description: "Do NLBs with TLS listeners have access logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "redshift_cluster_logging_check",
    Description: "Redshift cluster audit logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "neptune_cluster_audit_logging_check",
    Description: "Neptune audit logging enabled",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "log_metric_filter_for_cmk_api_call_changes",
    Description:
      "Ensure a log metric filter and alarm exist for disabling or scheduled deletion of customer managed keys",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "appmesh_logging_check",
    Description:
      "App Mesh virtual nodes should define an HTTP access log path to enable log exports for Envoy proxies",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "broker_audit_logging_check",
    Description: "Amazon MQ Message brokers should have audit logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "log_metric_filter_for_nacl_changes",
    Description:
      "Ensure a log metric filter and alarm exist for changes to Network Access Control Lists (NACL)",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "are_global_management_events_logged",
    Description:
      'Ensure global/management events logged in trails, CloudTrail management events (also known as "control plane operations") show management operations that are performed on resources in your AWS account.',
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "broker_general_logging_check",
    Description:
      "Amazon MQ Message brokers should have general logging enabled",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "log_metric_filter_for_iam_policy_changes",
    Description:
      "Ensure a log metric filter and alarm exist for IAM policy changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
  {
    CheckId: "is_cloudwatch_log_forwarding_enabled",
    Description:
      "Ensure log forwarding enabled on Directory Service directory, this helps you to meet your security monitoring, audit, and log retention policy requirements by providing transparency of the security events in your directory.",
    ErrorMessages: null,
    Status: "PASSED",
  },
  {
    CheckId: "log_metric_filter_for_security_group_changes",
    Description:
      "Ensure a log metric filter and alarm exist for security group changes",
    ErrorMessages: null,
    Status: "FAILED",
  },
];

export const Performance_Q7_documentdb_cluster_audit_logging_on = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q7_emr_cluster_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q7_cloud_trail_s3_bucket_logging_enabled_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_s3_bucket_logging_enabled_check",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "50eeb7e0-0b8c-4aa3-88fe-7d520d90a607",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation:
        "Ensure that any S3 buckets used by AWS CloudTrail have Server Access Logging feature enabled in order to track requests for accessing the buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:s3:::cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "High",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "cloud_trail_s3_bucket_logging_enabled_check",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "cfe077d4-cfb3-4dde-82d1-d87a921e115f",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation:
        "Ensure that any S3 buckets used by AWS CloudTrail have Server Access Logging feature enabled in order to track requests for accessing the buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "arn:aws:s3:::montycloud-cloud-trail-log-181570489212",
      ResourceType: "CloudTrail",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Performance_Q7_log_metric_filter_for_vpc_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_vpc_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "8fdb2913-7608-4ddb-916b-26bf5e15b9a4",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to VPCs is present. Monitoring these changes helps ensure that authentication and authorization controls remain intact",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Performance_Q7_is_stage_api_logging_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "is_stage_api_logging_enabled",
      CreatedAt: "2023-04-25 12:24:16",
      FindingId: "47429d9d-a8c5-4156-9c1a-bf3e183a6090",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation: "Ensure stage API logging enabled on API Gateway",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:apigateway:us-east-1::/restapis/2edfnla881/stages/unencrpytcache",
      ResourceType: "APIGatewayStage",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "is_stage_api_logging_enabled",
      CreatedAt: "2023-04-25 12:24:16",
      FindingId: "818f91ff-472d-44ce-ad3c-113cf60a0f01",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation: "Ensure stage API logging enabled on API Gateway",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "arn:aws:apigateway:us-east-1::/restapis/2edfnla881/stages/dev",
      ResourceType: "APIGatewayStage",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Performance_Q7_blockchain_fabric_peer_node_logs_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q7_ram_resource_shares_status_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q7_amb_fabric_node_chaincode_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q7_log_metric_filter_for_route_table_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_route_table_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "77cf9bdc-5231-4966-a100-d9c9262dec5f",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to route tables is present. Monitoring these changes helps ensure that all VPC traffic flows through an expected path.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Performance_Q7_rds_instance_cloudwatch_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "rds_instance_cloudwatch_logging_check",
      CreatedAt: "2023-04-25 12:23:31",
      FindingId: "0f966e45-30f8-4153-8d6f-f94c28145399",
      Metadata: {
        TaskRefId: "5fc5c01f-6db1-43b9-b9f4-401dea001486",
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation:
        "By publishing database logs to Amazon CloudWatch, you can build richer and more seamless interactions with your database instance logs using AWS services. Log Exports is supported by AWS RDS MySQL, Aurora (with MySQL compatibility) and MariaDB database engines. \n This check verifies if CloudWatch logging is enabled for Amazon RDS database instances.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:humantech-production-auroradbnc-auroradbinstancenc-x3zemswe8mqo",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "rds_instance_cloudwatch_logging_check",
      CreatedAt: "2023-04-25 12:23:31",
      FindingId: "6b5d064f-aa5f-4089-ade5-ffe21f29e6ab",
      Metadata: {
        TaskRefId: "5fc5c01f-6db1-43b9-b9f4-401dea001486",
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation:
        "By publishing database logs to Amazon CloudWatch, you can build richer and more seamless interactions with your database instance logs using AWS services. Log Exports is supported by AWS RDS MySQL, Aurora (with MySQL compatibility) and MariaDB database engines. \n This check verifies if CloudWatch logging is enabled for Amazon RDS database instances.",
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:rds:us-east-1:181570489212:db:wartestrds1noncompliant-181570489212",
      ResourceType: "Rds",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 2,
};
export const Performance_Q7_log_metric_filter_for_network_gateway_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_network_gateway_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "ae2d1523-e6e2-447f-b380-d7a603368187",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to network gateways is present. Monitoring these changes helps ensure that all ingress and egress traffic traverses the VPC border via a controlled path.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "High",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Performance_Q7_kinesis_analytics_application_log_to_cloudwatch_check =
  {
    CurrentOffset: 0,
    Limit: 10,
    Records: [],
    TotalRecords: 0,
  };
export const Performance_Q7_are_stacks_monitored = {
  CurrentOffset: 0,
  Limit: 10,
  NextOffset: 1,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "are_stacks_monitored",
      CreatedAt: "2023-04-25 12:24:26",
      FindingId: "0bd33c75-35d6-4744-a776-c4b2732638c4",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation: "Ensure cloudformation stacks are monitored",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "MontyCloud-OnBoarding-Role-SecurityBotPermissions-1OIYAMFRAAYUD",
      ResourceType: "Cfn",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "are_stacks_monitored",
      CreatedAt: "2023-04-25 12:24:26",
      FindingId: "0dfb514f-3cde-41da-8fc8-5ede3171c1bc",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation: "Ensure cloudformation stacks are monitored",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-ECRpublicrepoNC-3F4R6UEL1Z39",
      ResourceType: "Cfn",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "are_stacks_monitored",
      CreatedAt: "2023-04-25 12:24:26",
      FindingId: "14f6e443-ff5c-4553-bde8-ea3a1800226a",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation: "Ensure cloudformation stacks are monitored",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-DynamodbNonComplaint-RYGTGXLR5XUE",
      ResourceType: "Cfn",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "are_stacks_monitored",
      CreatedAt: "2023-04-25 12:24:26",
      FindingId: "167c05d3-2368-4cfb-9c59-24a65d5e89be",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation: "Ensure cloudformation stacks are monitored",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "MontyCloud-OnBoarding-Role-SNSTopicPermissions-Q4ZCM9Y6A4YP",
      ResourceType: "Cfn",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "are_stacks_monitored",
      CreatedAt: "2023-04-25 12:24:26",
      FindingId: "266939bf-02cd-4b7e-a68d-000c035ec6c5",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation: "Ensure cloudformation stacks are monitored",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-VPCSGNonCompliant-1TNM1QRMXJE1A",
      ResourceType: "Cfn",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "are_stacks_monitored",
      CreatedAt: "2023-04-25 12:24:26",
      FindingId: "4d196dd4-5240-4778-bf61-85ad64d70f40",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation: "Ensure cloudformation stacks are monitored",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-CloudtrailNonCompliant-19WQGRB5R076E",
      ResourceType: "Cfn",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "are_stacks_monitored",
      CreatedAt: "2023-04-25 12:24:26",
      FindingId: "5f144536-0809-4fba-a89f-3eb2aa785779",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation: "Ensure cloudformation stacks are monitored",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-AuroradbNC-1NRRMYVKOWQU",
      ResourceType: "Cfn",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "are_stacks_monitored",
      CreatedAt: "2023-04-25 12:24:26",
      FindingId: "6209e332-fa4b-460d-b001-4740bb3cbaef",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation: "Ensure cloudformation stacks are monitored",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "HumanTech-Production-KMSCMKNC-13FS8SPAJEQLV",
      ResourceType: "Cfn",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "are_stacks_monitored",
      CreatedAt: "2023-04-25 12:24:26",
      FindingId: "6adf8ab2-130c-4037-a485-a4c69bce70b3",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation: "Ensure cloudformation stacks are monitored",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "HumanTech-Production-KinesisStreamNonCompliant-15P6JJD70MQXI",
      ResourceType: "Cfn",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "are_stacks_monitored",
      CreatedAt: "2023-04-25 12:24:26",
      FindingId: "73247ec3-7388-48f8-9be1-877f7a1ce0fe",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation: "Ensure cloudformation stacks are monitored",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "HumanTech-Production-UnusedResourcesNonCompliant-109RHAL4LPGV7",
      ResourceType: "Cfn",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 19,
};
export const Performance_Q7_amb_fabric_member_ca_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q7_log_metric_filter_for_aws_config_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_aws_config_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "46e0ba89-5516-4bf3-852d-a42d8e839874",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to AWS Config configuration settings is present. Monitoring these changes helps ensure sustained visibility of configuration items in the account.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Performance_Q7_log_metric_filter_for_s3_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_s3_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "8e85e368-a7b9-4f03-93ca-4ab66e0f3462",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to S3 bucket policies is present. Monitoring these changes might reduce time to detect and correct permissive policies on sensitive S3 buckets",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Performance_Q7_is_cloudwatch_logging_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q7_elbv2_nlb_tls_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q7_redshift_cluster_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q7_neptune_cluster_audit_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "neptune_cluster_audit_logging_check",
      CreatedAt: "2023-04-25 12:24:43",
      FindingId: "65c2ffc5-685a-4163-8ada-f213b57518c5",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation:
        "To audit Amazon Neptune DB cluster activity, enable the collection of audit logs by setting a DB cluster parameter. When audit logs are enabled, you can use it to log any combination of supported events. You can view or download the audit logs to review them.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId:
        "humantech-production-auroradbnc-auroradbclusternc-h0etehondbyg",
      ResourceType: "NeptuneCluster",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Performance_Q7_log_metric_filter_for_cmk_api_call_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_cmk_api_call_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "62bd91aa-8513-4ffb-b752-a363c4592de0",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation:
        "Ensure a log metric filter and alarm exist for disabling or scheduled deletion of customer managed keys",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Performance_Q7_appmesh_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q7_broker_audit_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q7_log_metric_filter_for_nacl_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_nacl_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "d3b7b63f-d493-46a1-88ed-c73a021ce628",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to NACLs is present. Monitoring these changes helps ensure that AWS resources and services aren't unintentionally exposed",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Performance_Q7_are_global_management_events_logged = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "are_global_management_events_logged",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "43bc106e-9acf-4d72-ab2a-ef394cf943fe",
      Metadata: {
        TaskRefId: "55f3b24e-4711-4c6d-b492-db3ac3abfd9e",
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation:
        'Ensure global/management events logged in trails, CloudTrail management events (also known as "control plane operations") show management operations that are performed on resources in your AWS account.',
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/cloud-trail-ba451140-e354-11ed-9768-0ee4cc0d366d",
      ResourceType: "CloudTrail",
      Severity: "Low",
      Status: "Failed",
    },
    {
      AccountNumber: "181570489212",
      CheckId: "are_global_management_events_logged",
      CreatedAt: "2023-04-25 12:23:28",
      FindingId: "669981aa-5d78-4264-87be-62f18e9a9b5a",
      Metadata: {
        TaskRefId: "55f3b24e-4711-4c6d-b492-db3ac3abfd9e",
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation:
        'Ensure global/management events logged in trails, CloudTrail management events (also known as "control plane operations") show management operations that are performed on resources in your AWS account.',
      RegionCode: "us-east-1",
      Remediation: true,
      ResourceId:
        "arn:aws:cloudtrail:us-east-1:181570489212:trail/MC-CloudTrail-Log",
      ResourceType: "CloudTrail",
      Severity: "Informational",
      Status: "Passed",
    },
  ],
  TotalRecords: 2,
};
export const Performance_Q7_broker_general_logging_check = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q7_log_metric_filter_for_iam_policy_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_iam_policy_changes",
      CreatedAt: "2023-04-25 12:23:43",
      FindingId: "4246f610-d428-4948-b1d7-3be2dcaa83ed",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes made to IAM policies is present. Monitoring these changes helps ensure that authentication and authorization controls remain intact",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212",
      ResourceType: "LogMetricFilter",
      Severity: "Medium",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};
export const Performance_Q7_is_cloudwatch_log_forwarding_enabled = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [],
  TotalRecords: 0,
};
export const Performance_Q7_log_metric_filter_for_security_group_changes = {
  CurrentOffset: 0,
  Limit: 10,
  Records: [
    {
      AccountNumber: "181570489212",
      CheckId: "log_metric_filter_for_security_group_changes",
      CreatedAt: "2023-04-25 12:23:42",
      FindingId: "09a243cf-3bf3-4b37-98e3-324dc3679442",
      Metadata: {
        TaskRefId: null,
      },
      PillarId: "performance",
      QuestionId: "monitor-instances-post-launch",
      Recommendation:
        "This rule checks whether a metric filter and alarm for changes to security groups present. Monitoring these changes helps ensure that resources and services aren't unintentionally exposed.",
      RegionCode: "us-east-1",
      Remediation: false,
      ResourceId: "181570489212/us-east-1",
      ResourceType: "LogMetricFilter",
      Severity: "Low",
      Status: "Failed",
    },
  ],
  TotalRecords: 1,
};

export const PerformanceCheckFindings = {
  [`performing-architecture_dedicated_master_check`]:
    Performance_Q1_dedicated_master_check,
  [`performing-architecture_ebs_obtimized_instance_with_iops_check`]:
    Performance_Q1_ebs_obtimized_instance_with_iops_check,
  [`performing-architecture_ecs_cluster_default_provider_strategy_check`]:
    Performance_Q1_ecs_cluster_default_provider_strategy_check,
  [`performing-architecture_api_gateway_stage_caching_enabled_check`]:
    Performance_Q1_api_gateway_stage_caching_enabled_check,

  [`continue-having-appropriate-resource-type_eks_latest_k8s_version_check`]:
    Performance_Q6_eks_latest_k8s_version_check,
  [`continue-having-appropriate-resource-type_dms_replication_instance_minor_version_update_check`]:
    Performance_Q6_dms_replication_instance_minor_version_update_check,
  [`continue-having-appropriate-resource-type_broker_minor_version_auto_upgrade_check`]:
    Performance_Q6_broker_minor_version_auto_upgrade_check,
  [`continue-having-appropriate-resource-type_elastic_update_check`]:
    Performance_Q6_elastic_update_check,

  [`monitor-instances-post-launch_documentdb_cluster_audit_logging_on`]:
    Performance_Q7_documentdb_cluster_audit_logging_on,
  [`monitor-instances-post-launch_emr_cluster_logging_check`]:
    Performance_Q7_emr_cluster_logging_check,
  [`monitor-instances-post-launch_cloud_trail_s3_bucket_logging_enabled_check`]:
    Performance_Q7_cloud_trail_s3_bucket_logging_enabled_check,
  [`monitor-instances-post-launch_log_metric_filter_for_vpc_changes`]:
    Performance_Q7_log_metric_filter_for_vpc_changes,
  [`monitor-instances-post-launch_is_stage_api_logging_enabled`]:
    Performance_Q7_is_stage_api_logging_enabled,
  [`monitor-instances-post-launch_blockchain_fabric_peer_node_logs_enabled`]:
    Performance_Q7_blockchain_fabric_peer_node_logs_enabled,
  [`monitor-instances-post-launch_ram_resource_shares_status_check`]:
    Performance_Q7_ram_resource_shares_status_check,
  [`monitor-instances-post-launch_amb_fabric_node_chaincode_logging_check`]:
    Performance_Q7_amb_fabric_node_chaincode_logging_check,
  [`monitor-instances-post-launch_log_metric_filter_for_route_table_changes`]:
    Performance_Q7_log_metric_filter_for_route_table_changes,
  [`monitor-instances-post-launch_rds_instance_cloudwatch_logging_check`]:
    Performance_Q7_rds_instance_cloudwatch_logging_check,
  [`monitor-instances-post-launch_log_metric_filter_for_network_gateway_changes`]:
    Performance_Q7_log_metric_filter_for_network_gateway_changes,
  [`monitor-instances-post-launch_kinesis_analytics_application_log_to_cloudwatch_check`]:
    Performance_Q7_kinesis_analytics_application_log_to_cloudwatch_check,
  [`monitor-instances-post-launch_are_stacks_monitored`]:
    Performance_Q7_are_stacks_monitored,
  [`monitor-instances-post-launch_amb_fabric_member_ca_logging_check`]:
    Performance_Q7_amb_fabric_member_ca_logging_check,
  [`monitor-instances-post-launch_log_metric_filter_for_aws_config_changes`]:
    Performance_Q7_log_metric_filter_for_aws_config_changes,
  [`monitor-instances-post-launch_log_metric_filter_for_s3_changes`]:
    Performance_Q7_log_metric_filter_for_s3_changes,
  [`monitor-instances-post-launch_is_cloudwatch_logging_enabled`]:
    Performance_Q7_is_cloudwatch_logging_enabled,
  [`monitor-instances-post-launch_elbv2_nlb_tls_logging_check`]:
    Performance_Q7_elbv2_nlb_tls_logging_check,
  [`monitor-instances-post-launch_redshift_cluster_logging_check`]:
    Performance_Q7_redshift_cluster_logging_check,
  [`monitor-instances-post-launch_neptune_cluster_audit_logging_check`]:
    Performance_Q7_neptune_cluster_audit_logging_check,
  [`monitor-instances-post-launch_log_metric_filter_for_cmk_api_call_changes`]:
    Performance_Q7_log_metric_filter_for_cmk_api_call_changes,
  [`monitor-instances-post-launch_appmesh_logging_check`]:
    Performance_Q7_appmesh_logging_check,
  [`monitor-instances-post-launch_broker_audit_logging_check`]:
    Performance_Q7_broker_audit_logging_check,
  [`monitor-instances-post-launch_log_metric_filter_for_nacl_changes`]:
    Performance_Q7_log_metric_filter_for_nacl_changes,
  [`monitor-instances-post-launch_are_global_management_events_logged`]:
    Performance_Q7_are_global_management_events_logged,
  [`monitor-instances-post-launch_broker_general_logging_check`]:
    Performance_Q7_broker_general_logging_check,
  [`monitor-instances-post-launch_log_metric_filter_for_iam_policy_changes`]:
    Performance_Q7_log_metric_filter_for_iam_policy_changes,
  [`monitor-instances-post-launch_is_cloudwatch_log_forwarding_enabled`]:
    Performance_Q7_is_cloudwatch_log_forwarding_enabled,
  [`monitor-instances-post-launch_log_metric_filter_for_security_group_changes`]:
    Performance_Q7_log_metric_filter_for_security_group_changes,
};
